module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    ref: "barraControle",
    staticClass: "control-sidebar control-sidebar-light barraControle",
    staticStyle: {
      "position": "fixed"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab-agenda"
    }
  }, [_c('h3', {
    staticClass: "agendaTitulo"
  }, [_vm._v("\n          Agenda de Vencimentos\n          "), _c('div', {
    staticClass: "agendaFiltros"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Mandato de Dirigentes</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.filtrar('Mandato dirigente')
      }
    }
  }, [_c('i', {
    class: 'fa ' + _vm.icones['Mandato dirigente'] + (_vm._.includes(this.ocultarTipo, 'Mandato dirigente') ? ' filtroAtivo' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "agendaContador"
  }, [_vm._v(_vm._s(_vm.ehNulo(_vm.contador['Mandato dirigente'], 0)))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Acompanhamento de projeto</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.filtrar('Acompanhamento')
      }
    }
  }, [_c('i', {
    class: 'fa ' + _vm.icones['Acompanhamento'] + (_vm._.includes(this.ocultarTipo, 'Acompanhamento') ? ' filtroAtivo' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "agendaContador"
  }, [_vm._v(_vm._s(_vm.ehNulo(_vm.contador['Acompanhamento'], 0)))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Relatórios de Execução</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.filtrar('Relatório de Execução')
      }
    }
  }, [_c('i', {
    class: 'fa ' + _vm.icones['Relatório de Execução'] + (_vm._.includes(this.ocultarTipo, 'Relatório de Execução') ? ' filtroAtivo' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "agendaContador"
  }, [_vm._v(" " + _vm._s(_vm.ehNulo(_vm.contador['Relatório de Execução'], 0)))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Documentos diversos</h5>'
    },
    on: {
      "click": function($event) {
        return _vm.filtrar('Documento')
      }
    }
  }, [_c('i', {
    class: 'fa ' + _vm.icones['Documento'] + (_vm._.includes(this.ocultarTipo, 'Documento') ? ' filtroAtivo' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "agendaContador"
  }, [_vm._v(" " + _vm._s(_vm.ehNulo(_vm.contador['Documento'], 0)))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "title": '<h5>Período de vencimentos de<br/>' + _vm.dataFormat(_vm._.head(_vm._.keys(_vm.agenda))) + ' (semana anterior)<br/>até ' + _vm.dataFormat(_vm._.last(_vm._.keys(_vm.agenda))) + ' (' + _vm.mesesDepois + ' meses)</h5>'
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "listaVencimentos",
    style: ('height: 450px;')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "top": "20px",
      "left": "50%",
      "position": "relative",
      "font-size": "20px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._l((_vm._.keys(_vm.agenda)), function(data) {
    return [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm._.filter(_vm.agenda[data], function(i) {
          return !_vm._.has(i, 'mostrar') || i.mostrar
        })).length > 0),
        expression: "(_.filter(agenda[data], function (i) { return !_.has(i, 'mostrar') || i.mostrar })).length > 0"
      }]
    }, [_c('div', {
      staticClass: "agendaData"
    }, [_vm._v(_vm._s(_vm._f("moment")(data, "LL")) + "\n                "), (data === _vm.hoje) ? _c('span', {
      staticClass: "agendaHoje"
    }, [_vm._v("hoje")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.agenda[data]), function(item) {
      return [_c('li', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm._.has(item, 'mostrar') || item.mostrar),
          expression: "!_.has(item, 'mostrar') || item.mostrar"
        }, {
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            delay: 800,
            duration: 0,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{inertia:true, arrow:true, delay:800, duration:0, animation:'perspective', distance:'1', size:'large', arrow:true}"
        }],
        attrs: {
          "title": '<h5>' + _vm.infoTooltip(item) + '</h5>'
        },
        on: {
          "click": function($event) {
            return _vm.verificar(item)
          }
        }
      }, [_c('div', {
        staticClass: "agendaGrupo"
      }, [_c('i', {
        class: 'fa ' + _vm.icones[item.tipo]
      })]), _vm._v(" "), _c('div', {
        staticClass: "agendaOrigem"
      }, [_vm._v(_vm._s(_vm.origem(item)) + " ")]), _vm._v(" "), _c('div', {
        staticClass: "agendaDetalhe"
      }, [_c('span', {
        staticClass: "infoSubtipo"
      }, [_vm._v(_vm._s(item.subtipo))]), _vm._v(" " + _vm._s(item.info) + "\n                  ")])])]
    })], 2)]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-chat"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("Usuários logados")]), _vm._v(" "), _c('ul', [_vm._l((_vm.usuariosLogados), function(usuario) {
    return [_c('li', [_c('p', [_vm._v("Nome: " + _vm._s(usuario.ds_nome_usuario))]), _vm._v(" "), _c('p', [_vm._v("Login: " + _vm._s(usuario.ds_login))]), _vm._v(" "), _c('p', [_vm._v("E-mail: " + _vm._s(usuario.ds_email))]), _vm._v(" "), _c('p', [_vm._v("Tipo: " + _vm._s(usuario.ds_tipo_usuario))])])]
  })], 2)])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "control-sidebar-bg"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs nav-justified control-sidebar-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab-agenda",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-configuracao"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("Configurações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bea7c1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/ControlSidebar.vue
// module id = 1922
// module chunks = 2